import { AfterViewInit, Component } from "@angular/core"
import { UserService } from "../../../services/user.service"
import { EduComponent } from "../../../utils/eduComponent"
import Utils from "../../../utils/utils"

declare var window: any

@Component({
    selector: "app-student-projects",
    templateUrl: "./student-projects.component.html",
    styleUrls: ["./student-projects.component.less"],
})
export class StudentProjectsComponent extends EduComponent {
    public newProjectURL = window.PBSLM.NEW_STORYBOARD_URL
    public populationComplete = false
    public displayedCreations = []
    public activeCreations = []
    public creations = []
    public defaultLimit = 5

    constructor(private userService: UserService) {
        super()
        this.addSub(
            this.userService.studentProjects.subscribe((projects) => {
                this.creations = projects.slice()
                this.displayedCreations = this.creations.slice(0, this.defaultLimit)
                this.populationComplete = true
            })
        )
        this.userService.loadStudentProjects()
    }

    public isActive(code) {
        return this.activeCreations.indexOf(code) > -1
    }

    public toggleActive(code) {
        const index = this.activeCreations.indexOf(code)
        if (index > -1) {
            this.activeCreations.splice(index, 1)
        } else {
            this.activeCreations.push(code)
        }
    }

    public shouldPaginate() {
        if (this.defaultLimit != null) {
            return this.creations.length > this.defaultLimit
        }
    }

    public showMore() {
        this.defaultLimit += 5
    }

    public copyLinkByElementId(elemId) {
        Utils.copyLinkByElementId(elemId)
    }
}
